import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioPensionProductsCreateRequestDTO,
	postPortfolioPensionProductsV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePostPortfolioPensionProductsMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(requestContract: ClientPortfolioPensionProductsCreateRequestDTO) =>
				postPortfolioPensionProductsV2(requestContract),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
		},
	});
};
